import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { makeT } from "@/lib/i18n";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    if (!localStorage.getItem("sb_token")) return setUser(false);
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("sb_token");
      setUser(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const signIn = (data) => {
    localStorage.setItem("sb_token", data.token);
    setUser(data.user);
  };
  const logout = () => {
    localStorage.removeItem("sb_token");
    setUser(false);
  };
  const updateProfile = async (patch) => {
    const { data } = await api.patch("/auth/me", patch);
    setUser(data);
    return data;
  };
  const can = (perm) => !!user && user.permissions?.includes(perm);
  const t = useMemo(() => makeT(user?.language), [user?.language]);

  return <AuthCtx.Provider value={{ user, signIn, logout, refresh, updateProfile, can, t }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
